var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPassword(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M13.8308 4.71704C13.8308 7.32217 11.8401 9.43402 9.38431 9.43402C9.10085 9.43402 8.8237 9.40556 8.55496 9.35177L7.94832 10.0758C7.89143 10.1437 7.82163 10.198 7.74352 10.2352C7.66541 10.2724 7.58075 10.2917 7.49512 10.2917H6.55471V11.3637C6.55471 11.719 6.28325 12.0069 5.94837 12.0069H4.9378V13.079C4.9378 13.4342 4.66633 13.7222 4.33145 13.7222H1.50185C1.16697 13.7222 0.895508 13.4342 0.895508 13.079V10.9869C0.895508 10.8163 0.959401 10.6527 1.07309 10.5321L5.16091 6.19558C5.01632 5.73047 4.9378 5.2335 4.9378 4.71701C4.9378 2.11188 6.92855 2.68015e-05 9.38429 2.5602e-10C11.8473 -2.68009e-05 13.8308 2.10419 13.8308 4.71704ZM9.38431 3.43055C9.38431 4.14105 9.92724 4.71701 10.597 4.71701C11.2668 4.71701 11.8097 4.14105 11.8097 3.43055C11.8097 2.72005 11.2668 2.1441 10.597 2.1441C9.92724 2.1441 9.38431 2.72005 9.38431 3.43055Z",
    fill: "#808282"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPassword);
export default __webpack_public_path__ + "static/media/Password.354308b587fa8325f56b1c7246e4d162.svg";
export { ForwardRef as ReactComponent };